import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Form, Grid, Header, Button } from 'semantic-ui-react'
import { FormValidation, Field } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { createResult } from '../../common/results/actions'
import { loadActiveLocations } from '../../common/locations/actions'
import { validateCreate } from '../../common/results/validations'
import { courseTypesFormated } from '../../common/config'

const { Row, Column } = Grid

const courseTypeOptions = Object.keys(courseTypesFormated).map(
  key => ({ value: key, text: courseTypesFormated[key].name }),
)

class NewResult extends React.Component {
  componentWillMount() {
    this.props.loadActiveLocations({ sort: 'nameSort' })
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  async submit(e) {
    e.preventDefault()
    const { fields, submit, createResult, driver } = this.props
    const values = Object.assign({}, fields.$values(), { driver: driver._id })

    if (await submit(values, createResult) !== false) {
      fields.$reset()
    }
  }

  render() {
    const { fields, driver, locationOptions, errors, submitting, submitSuccessfull } = this.props
    if (submitSuccessfull) return <Redirect to="/results" />

    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field) fieldData[error.detail.field].error = error.message
    })

    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2">
                Základní údaje
              </Header>
            </Column>
          </Row>
          <Row>
            <Column width={4}>Řidič</Column>
            <Column width={8}>{driver.name} ({moment(driver.birtdate).format('D.M.YYYY')})</Column>
            <Column width={4} />
          </Row>
          <Field label="Lokace" type="select" options={locationOptions} {...fieldData.location} required />
          <Field label="Akce" type="select" options={courseTypeOptions} {...fieldData.courseType} required />
        </Grid>

        <Grid>
          <Row>
            <Column>
              <Button type="submit" onClick={(e) => this.submit(e)}>Uložit</Button>
            </Column>
          </Row>
        </Grid>

      </Form>
    )
  }
}

NewResult.defaultProps = {
  errors: [],
  submitting: false,
  submitSuccessfull: false,
}

NewResult.propTypes = {
  errors: React.PropTypes.array,
  fields: React.PropTypes.object.isRequired,
  driver: React.PropTypes.object.isRequired,
  locationOptions: React.PropTypes.object.isRequired,
  createResult: React.PropTypes.func.isRequired,
  loadActiveLocations: React.PropTypes.func.isRequired,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
}

NewResult = fields(NewResult, {
  path: 'NewResultForm',
  fields: [
    'location',
    'courseType',
  ],
})

NewResult = FormValidation(NewResult, () => ({ submissionValidation: validateCreate }))

export default connect((state) => ({
  locationOptions: state.locations.all.map(l => ({ value: l._id, text: l.name })).toArray(),
}), { createResult, loadActiveLocations })(NewResult)



// WEBPACK FOOTER //
// ./src/browser/forms/NewResult.js